import {systemConfig} from "../../framework/src/engine/madnes/madnes_variables";

export const assetsPath = "assets/";
var imgsPath = assetsPath + "img/";
export const audioPath = assetsPath + "audio/";

export const to_load = {
    'coin_sprite'				: 'framework/assets/img/coin/coins_{q}.png',
    'win_font_bg'				: imgsPath + 'fonts/win_font_bg_{q}.png',

    'background' 		: imgsPath + "reels/background_{q}.png",
    'reels_background' 	: imgsPath + "reels/reels_background_{q}.png",
    'reels_full_plate' 	: imgsPath + "reels/reels_full_plate_{q}.png",
    'reels-body' 		: imgsPath + "reels/reels-body_{q}.png",
    'winlines' 		: imgsPath + "reels/winlines_{q}.png",

    'active_winline_left_bottom' 	: imgsPath + "reels/active_winline_left_bottom_{q}.png",
    'active_winline_left_mid' 		: imgsPath + "reels/active_winline_left_mid_{q}.png",
    'active_winline_left_top' 		: imgsPath + "reels/active_winline_left_top_{q}.png",
    'active_winline_right_bottom' 	: imgsPath + "reels/active_winline_right_bottom_{q}.png",
    'active_winline_right_mid' 		: imgsPath + "reels/active_winline_right_mid_{q}.png",
    'active_winline_right_top' 		: imgsPath + "reels/active_winline_right_top_{q}.png",

    'winline_number_1' 			: imgsPath + "reels/winline_number_1_{q}.png",
    'winline_number_1_active' 	: imgsPath + "reels/winline_number_1_active_{q}.png",
    'winline_number_2' 			: imgsPath + "reels/winline_number_2_{q}.png",
    'winline_number_2_active' 	: imgsPath + "reels/winline_number_2_active_{q}.png",
    'winline_number_3' 			: imgsPath + "reels/winline_number_3_{q}.png",
    'winline_number_3_active' 	: imgsPath + "reels/winline_number_3_active_{q}.png",
    'winline_number_4' 			: imgsPath + "reels/winline_number_4_{q}.png",
    'winline_number_4_active' 	: imgsPath + "reels/winline_number_4_active_{q}.png",
    'winline_number_5' 			: imgsPath + "reels/winline_number_5_{q}.png",
    'winline_number_5_active' 	: imgsPath + "reels/winline_number_5_active_{q}.png",

    'star-counter' 	: imgsPath + "reels/star-counter_{q}.png",
    'gold-star' 	: imgsPath + "reels/gold-star_{q}.png",

    'settings_background_1' 	: imgsPath + "infos/settings_background_1_{q}.png",
    'settings_background_2' 	: imgsPath + "infos/settings_background_2_{q}.png",
    'settings_background_3' 	: imgsPath + "infos/settings_background_3_{q}.png",

    'bigwin_background_sprite' 	: imgsPath + "bigwin/bigwin_background_sprite_{q}.png",
    'bigwin_x2_background_sprite' 	: imgsPath + "bigwin/bigwin_x2_background_sprite_{q}.png",

    'x2' 	: imgsPath + "bigwin/x2_{q}.png",

    'big_win' 	: imgsPath + "bigwin/big_win_{q}.png",
    'mega_win' 	: imgsPath + "bigwin/mega_win_{q}.png",
    'super_mega_win' 	: imgsPath + "bigwin/super_mega_win_{q}.png",

    'win_background' 	: imgsPath + "bigwin/win_background_{q}.png",

    'symbol_Blue7_light' 	: imgsPath + "symbols/symbol_Blue7_light/symbol_Blue7_light_{q}.png",
    'symbol_BlueBar_light' 	: imgsPath + "symbols/symbol_BlueBar_light/symbol_BlueBar_light_{q}.png",
    'symbol_Diamond_light' 	: imgsPath + "symbols/symbol_Diamond_light/symbol_Diamond_light_{q}.png",
    'symbol_Cherry_light' 	: imgsPath + "symbols/symbol_Cherry_light/symbol_Cherry_light_{q}.png",
    'symbol_Red7_light' 	: imgsPath + "symbols/symbol_Red7_light/symbol_Red7_light_{q}.png",
    'symbol_RedBar_light' 	: imgsPath + "symbols/symbol_RedBar_light/symbol_RedBar_light_{q}.png",
    'symbol_Star_light' 	: imgsPath + "symbols/symbol_Star_light/symbol_Star_light_{q}.png",
    'symbol_White7_light' 	: imgsPath + "symbols/symbol_White7_light/symbol_White7_light_{q}.png",
    'symbol_WhiteBar_light' : imgsPath + "symbols/symbol_WhiteBar_light/symbol_WhiteBar_light_{q}.png",


    //'sparkle' 				: imgsPath + "bonus/sparkle_{q}.png",

    'arrows' 				: imgsPath + "bonus/arrows_{q}.png",
    'bonus_background' 		: imgsPath + "bonus/background_{q}.png",
    //'body' 					: imgsPath + "bonus/body_{q}.png",
    'bonus_arrow' 			: imgsPath + "bonus/bonus_arrow_{q}.png",
    'btn_spin_basic' 	    : imgsPath + "bonus/btn_spin_basic_{q}.png",
    'btn_spin_disabled' 	: imgsPath + "bonus/btn_spin_disabled_{q}.png",
    'btn_spin_pressed'	    : imgsPath + "bonus/btn_spin_pressed_{q}.png",
    //'btn_stop_basic' 		: imgsPath + "bonus/btn_stop_basic_{q}.png",
    //'btn_stop_disabled' 	: imgsPath + "bonus/btn_stop_disabled_{q}.png",
    //'btn_stop_pressed' 		: imgsPath + "bonus/btn_stop_pressed_{q}.png",
    'field_win' 			: imgsPath + "bonus/field_win_{q}.png",
    'multiplier_win' 		: imgsPath + "bonus/multiplier_win_{q}.png",
    'multiplier_dark' 		: imgsPath + "bonus/multiplier_dark_{q}.png",
    'multiplier_dark_all' 	: imgsPath + "bonus/multiplier_dark_all_{q}.png",
    'multipliers' 			: imgsPath + "bonus/multipliers_{q}.png",

    'shine' 				: imgsPath + "bonus/shine_{q}.png",

    'wheel' 				: imgsPath + "bonus/wheel_{q}.png",
    'wheel_dark' 			: imgsPath + "bonus/wheel_dark_{q}.png",
    'wheel_dark_all' 		: imgsPath + "bonus/wheel_dark_all_{q}.png",
    'bonus_symbol_bar_blue' 	: imgsPath + "bonus/symbols/symbol_bar_blue_{q}.png",
    'bonus_symbol_bar_red' 	: imgsPath + "bonus/symbols/symbol_bar_red_{q}.png",
    'bonus_symbol_bar_yellow' 	: imgsPath + "bonus/symbols/symbol_bar_yellow_{q}.png",
    'bonus_symbol_diamond' 		: imgsPath + "bonus/symbols/symbol_diamond_{q}.png",
    'bonus_symbol_cherry' 		: imgsPath + "bonus/symbols/symbol_cherry_{q}.png",
    'bonus_symbol_seven_blue' 	: imgsPath + "bonus/symbols/symbol_seven_blue_{q}.png",
    'bonus_symbol_seven_red' 	: imgsPath + "bonus/symbols/symbol_seven_red_{q}.png",
    'bonus_symbol_seven_yellow'	: imgsPath + "bonus/symbols/symbol_seven_yellow_{q}.png",
    'bonus_symbol_star' 		: imgsPath + "bonus/symbols/symbol_star_{q}.png",
};

export const to_load_json = {
    'infotext' 				: assetsPath + "info/info_{l}.json"
};

export const to_load_json_atlas = {

};

export const to_load_audio = {

    'Win_big_in'		:	audioPath + 'bwin_BigWin.ogg',
    'Win_mega_in'		:	audioPath + 'bwin_MegaWin.ogg',
    'Win_super_in'		:	audioPath + 'bwin_SuperMegaWin.ogg',
    //'Win_super_in_long'	:	audioPath + 'Win_super_in_long.ogg',

    'Reel_spin'			:	audioPath + 'reel_Spin.ogg',

    'Reel_stop_1'		:	audioPath + 'reel_Stop_1.ogg',
    'Reel_stop_2'		:	audioPath + 'reel_Stop_2.ogg',
    'Reel_stop_3'		:	audioPath + 'reel_Stop_3.ogg',

    'win_High_1'		:	audioPath + 'win_High_1.ogg',
    'win_High_2'		:	audioPath + 'win_High_2.ogg',
    'win_High_3'		:	audioPath + 'win_High_3.ogg',
    'win_High_4'		:	audioPath + 'win_High_4.ogg',
    'win_High_5'		:	audioPath + 'win_High_5.ogg',
    'win_Low_1'			:	audioPath + 'win_Low_1.ogg',
    'win_Low_2'			:	audioPath + 'win_Low_2.ogg',
    'win_Low_3'			:	audioPath + 'win_Low_3.ogg',
    'win_Low_4'			:	audioPath + 'win_Low_4.ogg',
    'win_Low_5'			:	audioPath + 'win_Low_5.ogg',

    'Wheel_bg1'			:	audioPath + 'bg_BonusWheel_1.ogg',
    'Wheel_bg2'			:	audioPath + 'bg_BonusWheel_2.ogg',
    'Wheel_bg3'			:	audioPath + 'bg_BonusWheel_3.ogg',
    'Wheel_fadeout'		:	audioPath + 'bonus_Wheel_FadeOut.ogg',

    '2x_symbol'			:	audioPath + 'win_Multiplier_Symbol.ogg',
    '2x_long'			:	audioPath + 'win_Multiplier_Long.ogg',
    '2x_short'			:	audioPath + 'win_Multiplier_Short.ogg',

    'win_Normal_Start'	:	audioPath + 'win_Normal_Start.ogg',
    'win_Normal_End'	:	audioPath + 'win_Normal_End.ogg',

    'Wheel_spin'		:	audioPath + 'bonus_Wheel_Spin.ogg',

    'Star_stop'			:	audioPath + 'symbol_Star.ogg',
    'Star_fill'			:	audioPath + 'symbol_Star_Fill.ogg',
	Jackpot_sound: assetsPath + "JokerWinBanner/Jackpot_sound.mp3",
	JokerBonus_alert: assetsPath + "JokerWinBanner/JokerBonus_alert.mp3",

};

export const to_load_fonts = {
    'win_font' :	{
        "img":	imgsPath + 'fonts/win_font.png',
        "xml":	imgsPath + 'fonts/win_font.xml'
    },

    'font_bigwin_mobile' :	{
        img:	imgsPath + 'fonts/font_bigwin_mobile.png',
        xml:	imgsPath + 'fonts/font_bigwin_mobile.xml',
    },
    'font_menu_mobile' :	{
        img:	imgsPath + 'fonts/font_menu_mobile.png',
        xml:	imgsPath + 'fonts/font_menu_mobile.xml',
    }
};

import {madnes_audio_allow_multiple, madnes_set_audio_volume} from "../../framework/src/engine/madnes/madnes_audio";
import {CONFIG_PARAMS} from "../../framework/src/system/SystemConfig";

export function set_sounds(server_config)
{
    if(typeof server_config.volume.bigWin != "undefined")
    {
        madnes_set_audio_volume('Win_big_in', server_config.volume.bigWin);
        madnes_set_audio_volume('Win_mega_in', server_config.volume.bigWin);
        madnes_set_audio_volume('Win_super_in', server_config.volume.bigWin);
    }
    if(typeof server_config.volume.buttonEffect != "undefined")
    {
        madnes_set_audio_volume('button_click', server_config.volume.buttonEffect);
    }
    if(typeof server_config.volume.spin != "undefined")
    {
        madnes_set_audio_volume('Reel_spin', server_config.volume.spin);
    }
    if(typeof server_config.volume.stopReel != "undefined")
    {
        madnes_set_audio_volume('Reel_stop_1', server_config.volume.stopReel);
        madnes_set_audio_volume('Reel_stop_2', server_config.volume.stopReel);
        madnes_set_audio_volume('Reel_stop_3', server_config.volume.stopReel);
    }
    if(typeof server_config.volume.winAnim != "undefined")
    {
        madnes_set_audio_volume('win_High_1', server_config.volume.winAnim);
        madnes_set_audio_volume('win_High_2', server_config.volume.winAnim);
        madnes_set_audio_volume('win_High_3', server_config.volume.winAnim);
        madnes_set_audio_volume('win_High_4', server_config.volume.winAnim);
        madnes_set_audio_volume('win_High_5', server_config.volume.winAnim);
        madnes_set_audio_volume('win_Low_1', server_config.volume.winAnim);
        madnes_set_audio_volume('win_Low_2', server_config.volume.winAnim);
        madnes_set_audio_volume('win_Low_3', server_config.volume.winAnim);
        madnes_set_audio_volume('win_Low_4', server_config.volume.winAnim);
        madnes_set_audio_volume('win_Low_5', server_config.volume.winAnim);
    }
    if(typeof server_config.volume.winCounter != "undefined")
    {
        madnes_set_audio_volume('remittance_A', server_config.volume.winCounter);
        madnes_set_audio_volume('remittance_B', server_config.volume.winCounter);
    }
    if(typeof server_config.background.bonusGameBackground != "undefined")
    {
        madnes_set_audio_volume('Wheel_bg1', server_config.background.bonusGameBackground);
        madnes_set_audio_volume('Wheel_bg2', server_config.background.bonusGameBackground);
        madnes_set_audio_volume('Wheel_bg3', server_config.background.bonusGameBackground);
        madnes_set_audio_volume('Wheel_fadeout', server_config.background.bonusGameBackground);
    }
    if(typeof server_config.miscSounds.miscSounds1 != "undefined")
    {
        madnes_set_audio_volume('coins_loop', server_config.miscSounds.miscSounds1);
    }

    if(typeof server_config.miscSounds.miscSounds2 != "undefined")
    {
        madnes_set_audio_volume('2x_symbol', server_config.miscSounds.miscSounds2);
        madnes_set_audio_volume('2x_long', server_config.miscSounds.miscSounds2);
        madnes_set_audio_volume('2x_short', server_config.miscSounds.miscSounds2);
    }

    if(typeof server_config.miscSounds.miscSounds3 != "undefined")
    {
        madnes_set_audio_volume('win_Normal_Start', server_config.miscSounds.miscSounds3);
        madnes_set_audio_volume('win_Normal_End', server_config.miscSounds.miscSounds3);
    }
    if(typeof server_config.miscSounds.miscSounds4 != "undefined")
    {
        madnes_set_audio_volume('Wheel_spin', server_config.miscSounds.miscSounds4);
        madnes_audio_allow_multiple("Wheel_spin");
    }

    if(typeof server_config.miscSounds.miscSounds5 != "undefined")
    {
        madnes_set_audio_volume('Star_stop', server_config.miscSounds.miscSounds5);
        madnes_set_audio_volume('Star_fill', server_config.miscSounds.miscSounds5);
    }

}
